import { Card } from '@latitude/card';
import { FormCheckbox, FormInput, FormSelect, useFormContext } from '@latitude/form';
import type { SelectOption } from '@latitude/select';
import { Text } from '@latitude/text';
import { PORTO_TERMS } from 'components/porto/Signup/constants';
type Props = {
  countryOptions: SelectOption[];
  isCountryOptionsLoading: boolean;
};
function CompleteYourProfileContent({
  countryOptions,
  isCountryOptionsLoading
}: Props) {
  const {
    control
  } = useFormContext();
  return <div className="w-full flex flex-col gap-10" data-sentry-component="CompleteYourProfileContent" data-sentry-source-file="CompleteYourProfileContent.tsx">
      <Card className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-sentry-element="Card" data-sentry-source-file="CompleteYourProfileContent.tsx">
        <FormInput wrapperClassname="col-span-full" control={control} name="mainUserEmail" label="Email" type="email" inputSize="medium" data-sentry-element="FormInput" data-sentry-source-file="CompleteYourProfileContent.tsx" />
        <FormInput control={control} name="mainUserFirstName" label="First name" inputSize="medium" data-sentry-element="FormInput" data-sentry-source-file="CompleteYourProfileContent.tsx" />
        <FormInput control={control} name="mainUserLastName" label="Last name" inputSize="medium" data-sentry-element="FormInput" data-sentry-source-file="CompleteYourProfileContent.tsx" />
        <FormSelect wrapperClassname="col-span-full" control={control} name="mainUserCountry" label="Country of residence" options={countryOptions} loading={isCountryOptionsLoading} optional={false} data-sentry-element="FormSelect" data-sentry-source-file="CompleteYourProfileContent.tsx" />
      </Card>
      <div>
        <FormCheckbox control={control} checkboxLabel="I have read and accept the following:" name="mainUserCheckbox" data-sentry-element="FormCheckbox" data-sentry-source-file="CompleteYourProfileContent.tsx" />
        <ul className="flex flex-col gap-2 list-disc ml-12">
          {PORTO_TERMS.map(({
          title,
          url
        }) => <li key={title} className="text-color-ref-text-link-primary">
              <Text asChild className=" hover:text-color-ref-text-strong">
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {title}
                </a>
              </Text>
            </li>)}
        </ul>
      </div>
    </div>;
}
export { CompleteYourProfileContent };